import { useSetAtom } from 'jotai';
import { useReactFlow } from '@xyflow/react';
import { Pencil } from 'lucide-react';
import type { NodeSettingsProps } from '../../types';
import { functionWorkspaceRequestAtom } from '../../atoms/functionWorkspaceAtom';
import { useFlowDisplayLanguage } from '../../displayLanguage';

export function FunctionSettings({ node }: NodeSettingsProps<'function'>) {
  const { updateNodeData } = useReactFlow();
  const requestWorkspace = useSetAtom(functionWorkspaceRequestAtom);
  const displayLanguage = useFlowDisplayLanguage();
  const functionName = node.data.functionName ?? '';
  const canEdit = functionName.trim().length > 0;

  return (
    <div className="space-y-4 text-teal-700">
      <label className="block" data-product-tour="card-input-1">
        <span className="mb-1 block text-sm font-medium">
          {displayLanguage === 'en' ? 'Function name' : '関数名'}
        </span>
        <input
          type="text"
          value={functionName}
          onChange={(event) => updateNodeData(node.id, { functionName: event.target.value })}
          placeholder={displayLanguage === 'en' ? 'e.g. greeting' : '例: あいさつ'}
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-teal-400"
        />
      </label>
      <button
        type="button"
        disabled={!canEdit}
        onClick={() => requestWorkspace(node.id)}
        className="flex w-full items-center justify-center gap-2 rounded-lg bg-teal-600 px-4 py-2.5 font-semibold text-white transition-colors hover:bg-teal-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <Pencil aria-hidden="true" size={17} />
        {displayLanguage === 'en' ? 'Edit function' : '関数を編集'}
      </button>
    </div>
  );
}